var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stripeMounted)?_c('card-details-form',{staticClass:"max-w-sm mx-auto pb-24",attrs:{"allow-skip-card":_vm.allowNoCard,"enable-coupon-field":false},on:{"registered":_vm.handleSuccessfulRegistration}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }